/**
 * A promise that may never settle, given a limit: the Discord SDK answers through the host window
 * and a lost message means no answer at all (review 0027 C6). `onTimeout` builds the error.
 */
export function withTimeout<T>(
  promise: Promise<T>,
  ms: number,
  onTimeout: () => Error,
): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(onTimeout()), ms);
    promise.then(resolve, reject).finally(() => clearTimeout(timer));
  });
}
